import Notfound from '../components/index'


export default [
    {
        path: '*',
        component: Notfound,
        name: 'PageNotFound',
    },
]